import { useState } from "react";
import Header from "../../../../customs/Header";
import SettingsModal from "../Modal/settingsCustomModal";
import DynamicTable from "./Table";
import apiCall from "../../../../utils/apiCall";
import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { CircularProgress, styled } from "@mui/material";
import styles from "../css/routePayment.module.css";
import { AiOutlineSearch as SearchIcon } from "react-icons/ai";
import { IoReload as ReloadIcon } from "react-icons/io5";

// Types
interface DeactivateApplicant {
  ApplicantId: number;
  FirstName: string;
  LastName: string;
  ActionId: number;
  ApplicationDate: string;
  Gender: string;
  MaritalStatus: string;
  Email: string;
}

// API Function
const getDeactivateApplicants = async (
  search: string
): Promise<DeactivateApplicant[]> => {
  const res = await apiCall().get("/Applicant/GetAlApplicantPendingDisable", {
    params: { search },
  });

  const data = res?.data?.Data;
  return Array.isArray(data) ? data : [];
};

const DeactivateApplicantPage = () => {
  const [openModal, setOpenModal] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");

  const { data: applicants, isLoading, isError, error } = useQuery<
    DeactivateApplicant[],
    AxiosError
  >({
    queryKey: ["getDeactivateApplicants", searchQuery],
    queryFn: () => getDeactivateApplicants(searchQuery),
    keepPreviousData: true,
  });

  // Handlers
  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);
  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) =>
    setSearchQuery(e.target.value);

  const handleClearFilters = () => {
    setSearchQuery("");
  };

  const filteredApplicants = Array.isArray(applicants)
    ? applicants.filter((applicant) => {
        return Object.values(applicant)
          .join(" ")
          .toLowerCase()
          .includes(searchQuery.toLowerCase());
      })
    : [];

  return (
    <>
      <Header
        marginBlockEnd="63px"
        props={{
          firstName: "All Available For Removal Applicant Table",
          secondName: "(Delete in option)",
          buttonText: "",
        }}
        handleOpen={handleOpenModal}
      />

      <div className={styles.container}>
        <div className={styles.filterDiv}>
          <label className={styles.searchForm}>
            <span className={styles.sI}>
              <SearchIcon />
            </span>
            <input
              value={searchQuery}
              onChange={handleSearchChange}
              type="text"
              placeholder="Search"
            />
            <button className={styles.rBtn} type="button" onClick={handleClearFilters}>
              <ReloadIcon />
            </button>
          </label>
        </div>
      </div>

      {isLoading ? (
        <CircleStyle>
          <CircularProgress
            sx={{
              fontSize: "1rem",
              marginInline: "auto",
              display: "block",
              marginBlock: "2rem",
              color: "#11643C",
            }}
          />
        </CircleStyle>
      ) : isError ? (
        <StyledError>{error?.message}</StyledError>
      ) : (
        <DynamicTable data={filteredApplicants || []} />
      )}

      <SettingsModal
        open={openModal}
        cancel={handleCloseModal}
        maxWidth="800px"
        header="Route Payment"
        showrightIcon={false}
        // content={<CreateDeactivateApplicant handleClose={handleCloseModal} />}
      />
    </>
  );
};

export default DeactivateApplicantPage;

const StyledError = styled("p")`
  color: red;
  font-size: 1.4rem;
  display: flex;
`;

const CircleStyle = styled("div")`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;
